import React from "react"
import settings from "settings"
import Modal from "react-responsive-modal"
import Unsellable from "./modals/unsellable"
import PipsyModal from "./modals/modal"
import axios from "axios"
import userToken from "helpers/userToken"
import classNames from "classnames"

var TypeaheadField = require("react-typeahead").Typeahead

class Typeahead extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			foo: "",
			options: [],
			modal: false,
			modalMessage: "",
			modalComponent: "",
			isSuggestionOpen: false,
			value: {
				label: "",
				id: "",
			},
		}
		this.ref = React.createRef()
	}

	_handleSearch = (query) => {
		if (query.target.value.length <= 2) {
			return
		}
		var user = userToken()
		var data = query.target.value
		if (query.target.value) {
			axios
				.post(
					settings.ep + this.props.ep,
					{ q: data, extra: this.props.extra, super: this.props.super },
					{ headers: { Authorization: `Bearer ${user}` } }
				)
				.then((json) => {
					if (json) {
						this.setState({ options: json.data })
						if (this.props.callback) {
							this.props.callback(json.data, this.props.index)
						}
					} else {
						this.setState({ options: [] })
					}
				})
				.catch((error) => {
					console.log(error)
				})
		}

		if (this.props.onKeyUpMethod) {
			this.props.onKeyUpMethod()
		}
	}

	_handleSelect = (e) => {
		if (this.props.row) {
			// THis is a traffic row
			this.props.onChange(`rows[${this.props.rowIndex}][${this.props.name}]`, e.id)
		} else if (this.props.useLabel) {
			this.props.onChange(this.props.name, e.label)
		} else {
			if (e.id == -99) {
				if (e.code == 400) {
					this.setState({ modalComponent: 400 })
				} else if (e.code == 401) {
					this.setState({ modalComponent: 401 })
				}
				// error
				this.setState({
					modal: true,
					modalMessage: e.msg,
				})
			}
			if (this.props.returnAll) {
				// Used in tax rates on lot contracts
				this.props.onChange(this.props.name, e)
			} else {
				//console.log(e)
				this.props.onChange(this.props.name, e.id)
			}

			if (this.props.clearAfter) {
				this.ref.current.setEntryText("")
			}

			//? For realtors on the lot contract who need data, pass the requirement back up so we can get those email/phone fields.
			if (this.props.needRealtorData) {
				if (e.needData) this.props.needRealtorData(true)
				else this.props.needRealtorData(false)
			}
		}
		//this.props.onChange(this.props.name, e.id)
	}

	handleChange = (value) => {
		// THey have to pick from the list, so set every change to -1 denoting bad data.  On select, it updates.
		if (this.props.row) {
			this.props.onChange(`rows[${this.props.rowIndex}][${this.props.name}]`, "")
		} else if (this.props.freetype) {
			// used in lot management
			this.props.onChange(this.props.name, value.target.value)
			// This logic wipes the realtor brokerages teams + offices if they begin to type a new license number.
			if (this.props.clearBrokerages) {
				let path = this.props.name.split(".")
				path.pop()
				path = path.join(".")
				this.props.onChange(`${path}.realtor_office_office`, null)
				this.props.onChange(`${path}.realtor_office_team`, null)
				this.props.onChange(`${path}.realtor_office_name`, null)
			}
		} else {
			this.props.onChange(this.props.name, -1)
		}
	}

	handleBlur = () => {
		if (this.props.row) {
			// this is a row e.g traffic
			this.props.onBlur(`rows[${this.props.rowIndex}][${this.props.name}]`, true)
		} else {
			this.props.onBlur(this.props.name, true)
		}
		this.setState({ isSuggestionOpen: false })
		//this.props.onBlur(this.props.name, true)
	}

	onCloseModal = () => {
		this.setState({ modal: false })
	}

	_handleFocus = () => {
		this.setState({ isSuggestionOpen: true })
	}

	localLookup = (query) => {
		let v = query.target.value
		v = v.toLowerCase()
		let options = []
		// this is for local lookup, like properties in public
		_.forEach(this.props.dataset, (o) => {
			if (o.name.toLowerCase().includes(v)) {
				options.push({ id: o.id, label: o.name })
			}
		})
		this.setState({ options })
	}

	render() {
		// This can probably be cleaned up
		var modalContent = ""
		if (this.state.modalComponent == 400) {
			modalContent = <Unsellable />
		} else if (this.state.modalComponent == 401) {
			modalContent = <PipsyModal title="Home Unsellable" msg={this.state.modalMessage} />
		}
		// Put this in place because this library is old and if you clicked into a box, chose an option, then blurred and went to antoher box, the suggestion box would stick around...?
		let resultsClasses = classNames("form__typeaheadCont", {
			"form__typeaheadCont--isOpen": this.state.isSuggestionOpen,
			"form__typeaheadCont--isClosed": !this.state.isSuggestionOpen,
		})
		return (
			<div
				className={classNames({
					"w-full": this.props.fullWidth,
				})}>
				<TypeaheadField
					customClasses={{
						input: "form__input",
						results: resultsClasses,
						listItem: "form__typeaheadItem",
					}}
					filterOption={this.props.reversed ? "id" : "label"}
					displayOption="label"
					options={this.state.options}
					onKeyUp={this.props.dataset ? this.localLookup : this._handleSearch}
					onChange={this.handleChange}
					//value={this.props.value}
					onFocus={this._handleFocus}
					onBlur={this.handleBlur}
					placeholder={this.props.placeholder}
					onOptionSelected={this._handleSelect}
					maxVisible={20}
					//inputProps={{ autoComplete: "sale-street-address" }}
					ref={this.ref}
				/>
				<Modal classNames={{ modal: "pipsyModal" }} open={this.state.modal} onClose={this.onCloseModal} center>
					{modalContent}
				</Modal>
			</div>
		)
	}
}

export default Typeahead
